import React, { useRef } from "react";
import { t } from "../i18n";

// "Withdraw counter offer?" confirm on the Requests page. Split out of
// pages/RequestsPage.tsx; the page owns which order is being withdrawn.

type Props = {
  busy: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export default function WithdrawCounterModal({ busy, onCancel, onConfirm }: Props) {
  const withdrawDownOnBackdrop = useRef(false);
  return (
    <div
      className="soon-modal-overlay"
      onPointerDown={(e) => {
        withdrawDownOnBackdrop.current = e.target === e.currentTarget;
      }}
      onClick={(e) => {
        if (e.target !== e.currentTarget) return;
        if (!withdrawDownOnBackdrop.current) return;
        withdrawDownOnBackdrop.current = false;
        if (!busy) onCancel();
      }}
    >
      <div className="soon-modal withdraw-modal" onClick={(e) => e.stopPropagation()}>
        <h3>{t("withdrawCounterModal.withdrawCounterOffer")}</h3>
        <p>
          {t("withdrawCounterModal.areYouSureYou")}
        </p>
        <div className="withdraw-modal-actions">
          <button
            type="button"
            className="withdraw-cancel-btn"
            onClick={onCancel}
            disabled={busy}
          >
            {t("withdrawCounterModal.cancel")}
          </button>
          <button
            type="button"
            className="withdraw-go-btn"
            onClick={onConfirm}
            disabled={busy}
          >
            {busy ? t("withdrawCounterModal.withdrawing") : t("withdrawCounterModal.withdrawOffer")}
          </button>
        </div>
      </div>
    </div>
  );
}
